import { useQuery } from '@tanstack/react-query';
import { fetchAirportsTree } from './api';
import type { AirportsTree } from './types';

/** The tenant airports-tree for the header scope picker. Changes ~never
 *  intra-day — long client cache; the BFF composes it from the airline
 *  tenant config. */
export function useAirportsTree(enabled = true) {
  return useQuery<AirportsTree>({
    queryKey: ['operator-context', 'airports-tree'],
    queryFn: fetchAirportsTree,
    enabled,
    staleTime: 5 * 60_000,
  });
}
